// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_3U2_ThQmqH7Mtb8nBvsvZ","code":"_2fNy1UaD3ceZoOf_stsEkn","number":"_1qJ6PgbqIJDkCUcbJz8aTQ"};